import { useUser } from "@/Context/UserContext";

// src/config/FieldCalculationRules.js

export const FieldCalculationRules = [
  {
    form: "productMain",
    target: "exportProductMainAmount",
    dependsOn: [
      "exportProductMainQuantity",
      "exportProductMainUnitPrice",
      "exportProductMainPer",
    ],
    formula: ({
      exportProductMainQuantity,
      exportProductMainUnitPrice,
      exportProductMainPer,
    }) => {
      const qty = parseFloat(exportProductMainQuantity) || 0;
      const price = parseFloat(exportProductMainUnitPrice) || 0;
      const per = parseFloat(exportProductMainPer) || 1;
      const result = (qty * price) / per;
      return result;
    },
  },
  {
    form: "invoiceMain",
    target: "exportInvoicePackingorFob",
    dependsOn: ["exportInvoiceValue", "exportInvoiceproductvalue"],
    formula: ({ exportInvoiceValue, exportInvoiceproductvalue }) => {
      const invoiceValue = parseFloat(exportInvoiceValue);
      const productValue = parseFloat(exportInvoiceproductvalue);
      const result = invoiceValue - productValue;
      return result;
    },
  },
  {
    form: "invoiceMain",
    target: "importInvoiceValue",
    dependsOn: ["importProductValue"],
    formula: ({ importProductValue }) => {
      const value = parseFloat(importProductValue || 0);

      if (isNaN(value)) {
        console.log("❌ Parsed value is NaN");
        return undefined;
      }

      console.log("✅ Assigning to importInvoiceValue:", value);

      return value;
    }
  },
  {
    form: "InvoiceOtherCharges",
    target: "Miscellaneousamount",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "Miscellaneousrate",
    ],
  
    formula: ({ totalProductValue, Miscellaneousrate }) => {
      console.log("🔥 Formula received:", { totalProductValue, Miscellaneousrate });
  
      if (
        totalProductValue == null ||
        Miscellaneousrate == null
      ) {
        return undefined; // ⛔ Do not calculate yet
      }
  
      const amount =
        (Number(totalProductValue) * Number(Miscellaneousrate)) / 100;
  
      return Number(amount.toFixed(2));
    }
  },  
  {
    form: "InvoiceOtherCharges",
    target: "Agencyamount",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "Agencyrate",
    ],
    formula: ({ totalProductValue, Agencyrate }) => {
      console.log("🔥 Formula received:", { totalProductValue, Agencyrate });
  
      if (
        totalProductValue == null ||
        Agencyrate == null
      ) {
        return undefined; // ⛔ Do not calculate yet
      }
  
      const amount =
        (Number(totalProductValue) * Number(Agencyrate)) / 100;
  
      return Number(amount.toFixed(2));
    },
  },
  {
    form: "InvoiceOtherCharges",
    target: "Discountamount",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "Discountrate",
    ],
    formula: ({ totalProductValue, Discountrate }) => {
      console.log("🔥 Formula received:", { totalProductValue, Discountrate });
  
      if (!totalProductValue || !Discountrate) return 0;
  
      const amount =
        (Number(totalProductValue) * Number(Discountrate)) / 100;
  
      return Number(amount.toFixed(2));
    },
  },
  {
    form: "InvoiceOtherCharges",
    target: "Loadingamount",
    dependsOn: [
      "invoiceMain.totalProductValue",
      "Loadingrate",
    ],
    formula: ({ totalProductValue, Loadingrate }) => {
      console.log("🔥 Formula received:", { totalProductValue, Loadingrate });
  
      if (!totalProductValue || !Loadingrate) return 0;
  
      const amount =
        (Number(totalProductValue) * Number(Loadingrate)) / 100;
  
      return Number(amount.toFixed(2));
    },
  },
  {
    form: "exportProductGeneral",
    target : "exportProductGeneralTaxableValueINR",
    dependsOn: [
      "exportProductGeneralIGSTPymtStatus","invoiceMain.currencyValue","productMain.exportProductMainAmount"
    ],
    formula : ({exportProductGeneralIGSTPymtStatus,currencyValue,exportProductMainAmount}) =>{
      if(exportProductGeneralIGSTPymtStatus === "Export Against Payment"){
         const taxableValue = currencyValue * exportProductMainAmount;
         return taxableValue;
      }
    }
  },
   {
    form: "exportProductGeneral",
    target : "exportProductGeneralIGSTAmountINR",
    dependsOn: [  
      "exportProductGeneralIGSTRate","exportProductGeneralTaxableValueINR"
    ],
    formula : ({exportProductGeneralIGSTRate,exportProductGeneralTaxableValueINR}) =>{
      const IGSTPercentage = exportProductGeneralTaxableValueINR * (exportProductGeneralIGSTRate/100);
      return IGSTPercentage;
    }
  },
   {
    form: "exportProductGeneral",
    target : "exportProductGeneralCompCessAmountINR",
    dependsOn: [  
      "exportProductGeneralCompCess","exportProductGeneralTaxableValueINR"
    ],
    formula : ({exportProductGeneralCompCess,exportProductGeneralTaxableValueINR}) =>{
      const compCessPercentage = exportProductGeneralTaxableValueINR * (exportProductGeneralCompCess/100);
      return compCessPercentage;
    }
  },
  // {
  //   form: "exportProductGeneral",
  //   target : "exportProductGeneralPMVPerUnit",
  //   dependsOn: [  
  //     "exportProductGeneralCalcMethod","invoiceMain.exportInvoiceTOI","productMain.exportProductMainAmount","productMain.exportProductMainQuantity","invoiceMain.currencyValue"
  //   ],
  //   formula : ({exportProductGeneralCalcMethod,exportInvoiceTOI,exportProductMainAmount,exportProductMainQuantity,currencyValue}) =>{
  //     if(exportProductGeneralCalcMethod === "%age"){
  //       if(exportInvoiceTOI === "FOB"){
  //         console.log("FOB");
  //         const PMVPerUnit =((((exportProductMainAmount/exportProductMainQuantity)*currencyValue)*(10/100)) + ((exportProductMainAmount/exportProductMainQuantity)*currencyValue));
  //         return PMVPerUnit;
  //       }
  //       // else if(exportInvoiceTOI === "FOB"){
  //       //   console.log("FOB");
  //       //   const PMVPerUnit =((((exportInvoiceproductvalue)*currencyValue)*(10/100)) + (exportInvoiceproductvalue*currencyValue));
  //       //   return PMVPerUnit;
  //       // }
  //   }
  //   }
  // },
  // {
  //   form: "exportProductGeneral",
  //   target : "exportProductGeneralTotalPMV",
  //   dependsOn: [  
  //    "exportProductGeneralCalcMethod","invoiceMain.exportInvoiceTOI","productMain.exportProductMainAmount","invoiceMain.currencyValue"
  //   ],
  //   formula : ({exportProductGeneralCalcMethod,exportInvoiceTOI,exportProductMainAmount,currencyValue}) =>{
  //     if(exportProductGeneralCalcMethod === "%age"){
  //     if(exportInvoiceTOI === "FOB"){ 
  //       const PMVPerUnit =(((exportProductMainAmount*currencyValue)*(10/100)+ (exportProductMainAmount*currencyValue)));
  //       return PMVPerUnit;
  //     }
  //   }
  //   }
  // }
];
